import { PageHeader, SideNavbar, useHeaderBackLink, useHeaderTitle } from "@blend-ed/blendx-platform";
import { useOrgLogos } from '@blend-ed/blendx-platform/hooks';
import { getRoleAndPermissions } from "@blend-ed/blendx-platform/utils";
import { MobileNavbar, useMediaQuery } from "@blend-ed/blendx-ui";
import { getConfig } from "@edx/frontend-platform";
import { useIntl } from "@edx/frontend-platform/i18n";
import { AppContext } from "@edx/frontend-platform/react";
import Cookies from "js-cookie";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { Outlet, useNavigate } from "react-router-dom";
import GetContactModal from "../components/GetContactModal";
import getDashboardMenu from "../routes/DashboardMenu";

const DashboardIndex = () => {
  const { MobileMenu } = getDashboardMenu();
  const { ACCOUNT_PROFILE_URL, SHOW_CONTACT_FORM } = getConfig();
  const { authenticatedUser } = useContext(AppContext);
  const navigate = useNavigate();
  const { role } = getRoleAndPermissions();

  //? user data 
  const user = useMemo(() => ({
    name: authenticatedUser.name,
    username: authenticatedUser.username,
    email: authenticatedUser.email,
    role: role,
    image: authenticatedUser.profileImage?.imageUrlSmall,
    id: authenticatedUser.id
  }), [authenticatedUser, role]);

  const isTablet = useMediaQuery({ query: '(min-width: 768px)' })

  useEffect(() => {
    const orgName = Cookies.get('orgName');
    const href = window.location.href;
    if (!orgName) {
      navigate(`/organizations?next=${href}`);
    }
  }, []);

  return !isTablet ? (
    <>
      <DashboardContent
        user={user}
        showContactForm={SHOW_CONTACT_FORM}
      />
      <MobileNavbar menu={MobileMenu} user={user} profileLink={ACCOUNT_PROFILE_URL + '/user/' + user.username} />
    </>
  ) : (
    <SideNavbar>
      <DashboardContent
        user={user}
      />
    </SideNavbar>
  );
};

DashboardIndex.propTypes = {
  children: PropTypes.node
};

DashboardIndex.defaultProps = {
  children: null
};

function DashboardContent({
  user,
  showContactForm
}) {
  const intl = useIntl();
  const [headerTitle, setHeaderTitle] = useState(null);
  const { title } = useHeaderTitle();
  const { logoFavicon } = useOrgLogos();
  const { backLink } = useHeaderBackLink();

  useEffect(() => {
    if (title) {
      if (title.props && title.props.children) {
        const parent = intl.formatMessage(title.props.children[0].props);
        const child = intl.formatMessage(title.props.children[2].props);
        setHeaderTitle(`${parent} / ${child}`);
      } else if (title.props) {
        setHeaderTitle(intl.formatMessage(title.props));
      } else {
        setHeaderTitle(title);
      }
    }
  }, [title]);

  return (
    <>
      <Helmet>
        <title>{headerTitle}</title>
        <link rel="icon" href={logoFavicon} />
      </Helmet>
      <PageHeader backLink={backLink} />
      {showContactForm && (user.username === 'demostudent' || user.username === 'demostaff') &&
        <div className="contact-modal-container">
          <GetContactModal />
        </div>
      }
      <Outlet />
    </>
  );
}

export default DashboardIndex;